import script from "./myPostPage.vue?vue&type=script&setup=true&lang=js"
export * from "./myPostPage.vue?vue&type=script&setup=true&lang=js"

import "./myPostPage.vue?vue&type=style&index=0&id=6bcc3c9a&scoped=true&lang=scss"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bcc3c9a"]])

export default __exports__